import * as React from "react";

interface ITeam{
    img: string;
    content: string;
    name: string;
}

export class Member extends React.Component<ITeam, any>{
    constructor(props: ITeam){
        super(props);
    }
    render(){
        return (
            <div className="Member">
                <img className='Member__photo' src={`./assets/images/${this.props.img}`} alt={this.props.img} />
                <p className='Member__name'><b>{this.props.name}</b></p>
                <p className='Member__content'><i>{this.props.content}</i></p>
            </div>
        )
    }
}

export default function OurTeam(props: any) {
    return (
        <div className="OurTeam">
            <img className="OurTeam__bg1" src="/assets/images/background/polygon.svg" alt=""/>
            <div className='container'>
                <p className='InfoOurSite__title'><b>Our Team</b></p>
                <div className="row">
                    <div className="col-md-2 col-xs-0"></div>
                    <div className="col-md-4 col-xs-12">
                        <Member 
                            img='p4.png'
                            name='Giannis'
                            content='Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum'
                        />
                    </div>
                    <div className="col-md-4 col-xs-12">
                        <Member 
                            img='p5.png'
                            name='Giannis'
                            content='Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum'
                        />
                    </div>
                    <div className="col-md-2 col-xs-0"></div>
                </div>
            </div>
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/components/homepage/OurTeam.tsx